import styled from 'styled-components';

export const Container = styled.div`
  display:flex;
  flex-shrink: none;
  width: 100%;
  height: 100%;
  margin: 0;

  background: #000;

  .react-player {

    margin: 0;
  }
`;

